/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
export default {
  "sitecoreApiKey": "{DB2F1317-4D4F-4788-80A4-2145C59B0B6D}",
  "sitecoreApiHost": "/sc-proxy",
  "jssAppName": "aon_app",
  "authEndpoint": "/security/isLoggedIn",
  "defaultLanguage": "nl-NL",
  "graphQLEndpointPath": "/sitecore/api/graph",
  "collectivityApiHost": "https://service.aon.nl",
  "graphQLEndpoint": "/sc-proxy/sitecore/api/graph"
};